import { axios } from '@/common/api.service.js'

export default async function resolveCharacterForCombatDeploy(character) {
  if (!character?.slug) {
    return character
  }

  try {
    const response = await axios.get(`api/v1/characters/${character.slug}/`, {
      mode: 'same-origin',
    })

    if (!response?.data || typeof response.data !== 'object') {
      return character
    }

    return {
      ...character,
      ...response.data,
    }
  } catch {
    return character
  }
}
